var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "49px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.5 50.6",
    style: {
      enableBackground: "new 0 0 30.5 50.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000005958817602226850520000004438104031968588217_);}\r\n\t.st3{clip-path:url(#SVGID_00000126284466455656711670000013856487953053248151_);}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#BDB6B8;}\r\n\t.st6{fill:#1A1A1A;}\r\n\t.st7{fill:#ADA8AA;}\r\n\t.st8{fill:#262424;}\r\n\t.st9{fill:#1E8273;}\r\n\t.st10{fill:#239281;}\r\n\t.st11{fill:#262626;}\r\n\t.st12{fill:#0F0F0F;}\r\n\t.st13{fill:#212226;}\r\n\t.st14{opacity:0.25;}\r\n\t.st15{clip-path:url(#SVGID_00000138541592012682290600000003072244705150675349_);}\r\n\t.st16{opacity:0.15;}\r\n\t.st17{clip-path:url(#SVGID_00000178893251901415931500000005714078760364661655_);}\r\n\t.st18{clip-path:url(#SVGID_00000000205615253155904390000010719743209762837156_);}\r\n\t.st19{clip-path:url(#SVGID_00000074441760450635722610000017798640957564191117_);}\r\n\t.st20{clip-path:url(#SVGID_00000082343202325064829980000000704814403593936547_);}\r\n\t.st21{clip-path:url(#SVGID_00000060002913055590455700000015635143845972633489_);}\r\n\t.st22{fill:#DFDFDE;}\r\n\t.st23{fill:#1d3943;}\r\n\t.st24{fill:#B7CDC8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4425",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st22",
    d: "M13.7,30.2c-2.3,0-4.5-0.1-6.8-0.1c-2.3,0-4-0.9-4.5-2.9c-0.7-1.9-0.1-4,1.3-5.4 C9.6,15.5,15.4,9.2,21.3,2.9c2-2.1,4.7-2.3,6.3-0.3c1.8,2.1,1.6,4.8-0.5,7.1c-3.3,3.6-6.7,7.1-10,10.7c-0.3,0.3-0.6,0.7-0.9,1.1 c2.6,0,5.1,0.1,7.5,0.1c1.8,0,2.7,1.4,4.1,3c1.2,1.5,0.2,3.8-1.1,5.2c-1.9,1.9-3.7,3.7-5.9,5.8c2.2,2.3,4.1,4.4,6,6.4 c2.5,2.8,2,6.5-1.2,8c-1.6,0.7-3.5,0.3-4.6-1.1c-2.9-3.3-5.9-6.6-8.8-9.9c-1.8-1.9-1.8-4.8,0.1-6.7c0.5-0.6,1.1-1.1,1.6-1.6 L13.7,30.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st23",
    d: "M9.7,34.6L23,21c0.4-0.4,1.1-0.5,1.6,0c0,0,0,0,0,0l4.6,4.7c0.4,0.5,0.4,1.2,0,1.6L16,40.9 c-0.4,0.4-1.1,0.5-1.6,0c0,0,0,0,0,0l-4.6-4.7C9.3,35.7,9.3,35,9.7,34.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st24",
    d: "M20.4,44.9c0.6-2.3,3-3.7,5.4-3.1c0,0,0,0,0.1,0c2.4,0.7,3.7,3.2,3,5.5c-0.6,2.3-3,3.7-5.4,3.1 c0,0,0,0-0.1,0C21.1,49.7,19.7,47.2,20.4,44.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st10",
    d: "M30.1,6.7l-23.6,24c-0.4,0.4-1.1,0.4-1.6,0c0,0,0,0,0,0L0.3,26c-0.4-0.5-0.4-1.2,0-1.6l23.6-24 c0.4-0.4,1.1-0.4,1.6,0c0,0,0,0,0,0l4.7,4.8C30.6,5.5,30.6,6.3,30.1,6.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlex);
export default __webpack_public_path__ + "static/media/icon_flex.aa27cdfe6e4993f95eb60d8935de9841.svg";
export { ForwardRef as ReactComponent };